import { createContext } from 'react';

type EtimClassCodes = string[];

const EtimClassCodeContext = createContext<EtimClassCodes>([]);

export default EtimClassCodeContext;

export { EtimClassCodes };
